import { arregloLecturas } from "@components/lecturaVeloz/utils/lecturas";
import dashboardRoutesPaths from "@helpers/dashboardRoutesPaths/dashboardRoutesPaths";
import { guardarInfoParticipanteCompetencia } from "@helpers/httpRequests/httpRequestsGruposLectura/httpRequestsGruposLectura";
import { useState, useEffect, useRef, useCallback } from "react";
import { NotificationManager } from "react-notifications";

//TODO: modificar el como se reparte la lectura para que se use una funcion y retorne el objeto aleatorio junto conc su info.
// ─── Data ────────────────────────────────────────────────────────────────────

// const rand = Math.floor(Math.random() * 17);
const rand = Math.floor(Math.random() * (12 - 1 + 1)) + 12     
// const rand = Math.floor(Math.random() * (32 - 27 + 1)) + 27     
let lecturaSeleccionada = arregloLecturas[rand];


// ─── Brand tokens ─────────────────────────────────────────────────────────────
const C = {
  navy: "#00152a",
  navyMid: "#00243d",
  navyLight: "#003156",
  dark: "#212529",
  orange: "#ff9900",
  yellow: "#ffcc00",
  white: "#f8f9fa",
  muted: "#8a9bb0",
  mutedLt: "#b8c9d8",
};

// ─── Mock DB save ─────────────────────────────────────────────────────────────
async function saveResultsToDB(payload, idPerfil, totalWords, codigoCompetencia) {
  // TODO: replace with your real endpoint

  const {
    comprensionPorcentaje,
    palabrasPorMinuto,
    respuestasCorrectas,
    totalPreguntas,
    tiempoLecturaSegundos,
    titulo,
  }= payload;

  const payloadFinal = {
    comprensionObtenida: comprensionPorcentaje,
    palabrasPorMinuto,
    preguntasCorrectas: respuestasCorrectas,
    numeroPreguntas: totalPreguntas,
    tiempoLectura: tiempoLecturaSegundos,
    nombreLectura: titulo,
    palabrasLectura: totalWords,
    idPerfil,
    codigoCompetencia
  }
  
  try{
    await guardarInfoParticipanteCompetencia(payloadFinal);
      console.log("📤 Guardando resultados:", payload);
    // await new Promise((r) => setTimeout(r, 1200));
    return { success: true };
  }catch(error){
    console.log('Error al guardar la información del alumno');
    return { success: false };
  }



}

// ─── Helpers ──────────────────────────────────────────────────────────────────
const countWords = (t) => t.trim().split(/\s+/).length;
const formatTime = (s) => `${String(Math.floor(s / 60)).padStart(2, "0")}:${String(s % 60).padStart(2, "0")}`;
const scoreInfo = (p) => p >= 80 ? { label: "Excelente", color: "#22c55e" }
  : p >= 60 ? { label: "Bueno", color: C.orange }
    : p >= 40 ? { label: "Regular", color: C.yellow }
      : { label: "A mejorar", color: "#ef4444" };

const wpmInfo = (w) => w > 1200 ? { label: "Fuera de rango — realiza la evaluación con conciencia", color: "#ef4444" }
  : w >= 250 ? { label: "Avanzado", color: "#22c55e" }
    : w >= 150 ? { label: "Promedio", color: C.orange }
      : { label: "En desarrollo", color: C.yellow };

const difficultyInfo = (words) =>
  words <= 150 ? { label: "Básico", icon: "🟢", chipClass: "li-chip-green" } :
    words <= 300 ? { label: "Elemental", icon: "📗", chipClass: "li-chip-green" } :
      words <= 500 ? { label: "Intermedio", icon: "📘", chipClass: "li-chip-orange" } :
        words <= 800 ? { label: "Avanzado", icon: "📙", chipClass: "li-chip-yellow" } :
          words <= 1200 ? { label: "Superior", icon: "📕", chipClass: "li-chip-red" } :
            { label: "Experto", icon: "🔴", chipClass: "li-chip-red" };


// ─── Global CSS ───────────────────────────────────────────────────────────────
const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Nunito:wght@400;600;700;800;900&family=Nunito+Sans:wght@400;500;600&display=swap');
  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }

  .li { height:100vh; overflow-y:auto; background:${C.navy}; font-family:'Nunito Sans',sans-serif; color:${C.white}; }

  /* topbar */
  .li-bar {
    position:sticky; top:0; z-index:100;
    background:${C.navy}ef; backdrop-filter:blur(14px);
    border-bottom:1px solid ${C.navyLight};
    padding:12px 24px;
    display:flex; align-items:center; justify-content:space-between; gap:16px;
  }
  .li-bar-brand { display:flex; align-items:center; gap:10px; min-width:0; }
  .li-bar-dot   { width:10px; height:10px; border-radius:50%; background:linear-gradient(135deg,${C.orange},${C.yellow}); flex-shrink:0; }
  .li-bar-name  { font-family:'Nunito',sans-serif; font-size:14px; font-weight:800; color:${C.white}; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; }
  .li-bar-right { display:flex; align-items:center; gap:10px; }

  /* chips */
  .li-chip {
    display:inline-flex; align-items:center; gap:5px;
    padding:4px 13px; border-radius:100px;
    font-family:'Nunito',sans-serif; font-size:11px; font-weight:700;
    letter-spacing:.08em; text-transform:uppercase;
  }
  .li-chip-ghost  { background:transparent; border:1.5px solid ${C.navyLight}; color:${C.muted}; }
  .li-chip-orange { background:${C.orange}18; border:1.5px solid ${C.orange}55; color:${C.orange}; }
  .li-chip-yellow { background:${C.yellow}18; border:1.5px solid ${C.yellow}55; color:${C.yellow}; }

  /* timer */
  .li-timer {
    display:inline-flex; align-items:center; gap:8px;
    background:${C.navyMid}; border:1.5px solid ${C.navyLight};
    border-radius:100px; padding:6px 16px;
    font-family:'Nunito',sans-serif; font-size:14px; font-weight:800;
    letter-spacing:.05em; color:${C.muted}; transition:all .3s;
  }
  .li-timer.on { border-color:${C.orange}; color:${C.orange}; }
  .li-tdot { width:8px; height:8px; border-radius:50%; background:${C.navyLight}; flex-shrink:0; transition:background .3s; }
  .li-timer.on .li-tdot { background:${C.orange}; animation:lipulse 1.2s infinite; }

  /* buttons */
  .li-btn {
    display:inline-flex; align-items:center; justify-content:center; gap:8px;
    padding:12px 28px; border:none; border-radius:10px;
    font-family:'Nunito',sans-serif; font-size:14px; font-weight:800;
    cursor:pointer; transition:opacity .2s, transform .15s; white-space:nowrap;
  }
  .li-btn-primary { background:linear-gradient(135deg,${C.orange},${C.yellow}); color:${C.navy}; }
  .li-btn-primary:hover:not(:disabled) { opacity:.9; transform:translateY(-1px); }
  .li-btn-primary:disabled { background:${C.navyLight}; color:${C.muted}; cursor:default; transform:none; }
  .li-btn-ghost { background:transparent; border:1.5px solid ${C.navyLight}; color:${C.muted}; }
  .li-btn-ghost:hover:not(:disabled) { border-color:${C.orange}44; color:${C.mutedLt}; }
  .li-btn-ghost:disabled { opacity:.35; cursor:default; }

  /* card */
  .li-card { background:${C.navyMid}; border:1px solid ${C.navyLight}; border-radius:16px; padding:32px; }
  .li-card-accent { border-top:3px solid ${C.orange}; }

  /* accent bar */
  .li-accent { width:52px; height:4px; border-radius:2px; background:linear-gradient(90deg,${C.orange},${C.yellow}); margin-bottom:20px; }

  /* progress */
  .li-prog-wrap { display:flex; align-items:center; gap:12px; }
  .li-prog-track { flex:1; height:6px; background:${C.navyLight}; border-radius:3px; overflow:hidden; }
  .li-prog-fill  { height:100%; background:linear-gradient(90deg,${C.orange},${C.yellow}); border-radius:3px; transition:width .4s ease; }
  .li-prog-label { font-family:'Nunito',sans-serif; font-size:12px; font-weight:700; color:${C.muted}; white-space:nowrap; }

  /* q-pill */
  .li-qp {
    width:34px; height:34px; border-radius:8px;
    border:1.5px solid ${C.navyLight}; background:${C.navyMid};
    color:${C.muted}; font-family:'Nunito',sans-serif;
    font-size:12px; font-weight:700; cursor:pointer; transition:all .15s;
    display:flex; align-items:center; justify-content:center;
  }
  .li-qp.answered { border-color:${C.orange}55; background:${C.orange}10; color:${C.orange}; }
  .li-qp.active   { border-color:${C.orange}; background:${C.orange}20; color:${C.orange}; box-shadow:0 0 0 3px ${C.orange}22; }

  /* option */
  .li-opt {
    width:100%; text-align:left; padding:14px 18px; border-radius:12px;
    border:1.5px solid ${C.navyLight}; background:${C.navy};
    color:${C.mutedLt}; font-family:'Nunito Sans',sans-serif; font-size:14px; line-height:1.5;
    cursor:pointer; transition:all .15s;
    display:flex; align-items:center; gap:12px;
  }
  .li-opt:hover:not(.sel) { border-color:${C.orange}44; color:${C.white}; }
  .li-opt.sel { border-color:${C.orange}; background:${C.orange}12; color:${C.white}; }
  .li-radio {
    width:22px; height:22px; border-radius:50%; flex-shrink:0;
    border:2px solid ${C.navyLight}; background:transparent;
    display:flex; align-items:center; justify-content:center;
    font-size:11px; font-weight:900; transition:all .15s; color:transparent;
  }
  .li-opt.sel .li-radio { border-color:${C.orange}; background:${C.orange}; color:${C.navy}; }

  /* metric */
  .li-metric {
    background:${C.navyMid}; border:1px solid ${C.navyLight};
    border-radius:16px; padding:24px 18px; text-align:center; position:relative; overflow:hidden;
  }
  .li-metric-glow { position:absolute; inset:0; pointer-events:none; border-radius:16px; }
  .li-metric-lbl  { font-family:'Nunito',sans-serif; font-size:10px; font-weight:700; letter-spacing:.12em; text-transform:uppercase; color:${C.muted}; margin-bottom:10px; }
  .li-metric-val  { font-family:'Nunito',sans-serif; font-size:36px; font-weight:900; line-height:1; margin-bottom:4px; }
  .li-metric-sub  { font-size:12px; color:${C.muted}; }

  /* review rows */
  .li-row { border-radius:12px; padding:16px 18px; display:flex; gap:14px; align-items:flex-start; }
  .li-row.ok  { background:#052013; border:1px solid #1a5c36; }
  .li-row.err { background:#1a0505; border:1px solid #7f1d1d; }
  .li-row-icon { width:28px; height:28px; border-radius:8px; flex-shrink:0; display:flex; align-items:center; justify-content:center; font-size:13px; font-weight:900; }
  .li-row.ok  .li-row-icon { background:#166534; color:#4ade80; }
  .li-row.err .li-row-icon { background:#7f1d1d; color:#f87171; }

  /* save */
  .li-save { border-radius:12px; padding:16px 20px; text-align:center; font-size:13px; font-weight:700; font-family:'Nunito',sans-serif; display:flex; align-items:center; justify-content:center; gap:8px; }
  .li-save.saving  { background:${C.navyMid}; border:1px solid ${C.navyLight}; color:${C.muted}; }
  .li-save.success { background:#052013; border:1px solid #1a5c36; color:#4ade80; }
  .li-save.error   { background:#1a0505; border:1px solid #7f1d1d; color:#f87171; }

  /* info grid */
  .li-grid3 { display:grid; grid-template-columns:repeat(3,1fr); gap:12px; }
  .li-cell  { background:${C.navyMid}; border:1px solid ${C.navyLight}; border-radius:14px; padding:18px 12px; text-align:center; }
  .li-cell-icon { font-size:22px; margin-bottom:8px; }
  .li-cell-key  { font-size:10px; color:${C.muted}; font-weight:700; letter-spacing:.1em; text-transform:uppercase; margin-bottom:4px; font-family:'Nunito',sans-serif; }
  .li-cell-val  { font-size:13px; color:${C.mutedLt}; font-weight:600; font-family:'Nunito',sans-serif; }

  /* reading text */
  .li-para { font-size:17px; line-height:1.9; color:#c8d8e8; margin-bottom:28px; font-family:'Nunito Sans',sans-serif; text-align: justify }
  .li-para::first-letter { font-family:'Nunito',sans-serif; font-size:2.2em; font-weight:900; color:${C.orange}; float:left; line-height:.75; margin:6px 8px 0 0; }

  /* distribution bar */
  .li-distbar { display:flex; gap:6px; align-items:center; }
  .li-distcell { flex:1; height:28px; border-radius:6px; display:flex; align-items:center; justify-content:center; font-size:11px; font-weight:700; }

  /* divider */
  .li-div { height:1px; background:${C.navyLight}; margin:28px 0; }

  /* animations */
  @keyframes lipulse { 0%,100%{opacity:1} 50%{opacity:.35} }
  @keyframes lifadeup { from{opacity:0;transform:translateY(18px)} to{opacity:1;transform:translateY(0)} }
  @keyframes lislide  { from{opacity:0;transform:translateX(14px)} to{opacity:1;transform:translateX(0)} }

  .li-up0 { animation:lifadeup .5s ease both; }
  .li-up1 { animation:lifadeup .5s ease .08s both; }
  .li-up2 { animation:lifadeup .5s ease .16s both; }
  .li-up3 { animation:lifadeup .5s ease .24s both; }
  .li-slide { animation:lislide .3s ease both; }

  @media (max-width:520px) {
    .li-grid3 { grid-template-columns:1fr 1fr; }
    .li-grid3>*:last-child { grid-column:span 2; }
    .li-card { padding:20px 16px; }
  }
`;

// ─── Sub-components ───────────────────────────────────────────────────────────
function Topbar({ semana, right }) {
  return (
    <div className="li-bar">
      <div className="li-bar-brand">
        <span className="li-bar-dot" />
        <span className="li-bar-name">Lectura Inteligente · Evento de competencias</span>
      </div>
      <div className="li-bar-right">{right}</div>
    </div>
  );
}

function Timer({ seconds, on }) {
  return (
    <div className={`li-timer${on ? " on" : ""}`}>
      <span className="li-tdot" />
      {formatTime(seconds)}
    </div>
  );
}

function ProgressBar({ current, total }) {
  const pct = total > 0 ? Math.round((current / total) * 100) : 0;
  return (
    <div className="li-prog-wrap">
      <div className="li-prog-track">
        <div className="li-prog-fill" style={{ width: `${pct}%` }} />
      </div>
      <span className="li-prog-label">{current}/{total}</span>
    </div>
  );
}

function MetricCard({ label, value, sub, color, cls = "" }) {
  return (
    <div className={`li-metric ${cls}`}>
      <div className="li-metric-glow" style={{ background: `radial-gradient(circle at 50% -10%, ${color}22 0%, transparent 65%)` }} />
      <p className="li-metric-lbl">{label}</p>
      <p className="li-metric-val" style={{ color }}>{value}</p>
      <p className="li-metric-sub">{sub}</p>
    </div>
  );
}

// ─── Main ─────────────────────────────────────────────────────────────────────
export default function LecturaEvaluacion({
  history,
  lectura = lecturaSeleccionada,
  userId = "usuario_demo",
  semana = 1,
  usuarioLogeado,
  codigoCompetencia,
}) {
  const [phase, setPhase] = useState("intro");
  const [secs, setSecs] = useState(0);
  const [readTime, setReadTime] = useState(0);
  const [answers, setAnswers] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);
  const [saveErr, setSaveErr] = useState(null);
  const [results, setResults] = useState(null);
  const [activeQ, setActiveQ] = useState(0);
  const timerRef = useRef(null);
  const scrollRef = useRef(null);
  const totalWords = countWords(lectura.texto);

  // ── Scroll to top on every phase transition ────────────────────────────────
  useEffect(() => {
    scrollRef.current?.scrollTo({ top: 0, behavior: "smooth" });
  }, [phase]);

  useEffect(() => {
    if (phase === "results"){
      NotificationManager.success("Tus resultados se han guardado. Gracias por tu participación.")
    }
    if (phase === "reading") {
      timerRef.current = setInterval(() => setSecs((s) => s + 1), 1000);
    } else {
      clearInterval(timerRef.current);
    }
    return () => clearInterval(timerRef.current);
  }, [phase]);

  const startReading = useCallback(() => { setSecs(0); setPhase("reading"); }, []);
  const finishReading = useCallback(() => { setReadTime(secs); setPhase("quiz"); }, [secs]);
  const pickAnswer = useCallback((id, op) => {
    if (submitted) return;
    setAnswers((p) => ({ ...p, [id]: op }));
  }, [submitted]);

  const submitQuiz = useCallback(async () => {
    if (submitted) return;
    setSubmitted(true);
    const detail = lectura.preguntas.map((q) => ({
      id: q.id, pregunta: q.pregunta,
      seleccionada: answers[q.id] ?? null,
      correcta: answers[q.id] === q.respuesta,
      respuestaCorrecta: q.respuesta,
    }));
    const correct = detail.filter((d) => d.correcta).length;
    const comprension = Math.round((correct / lectura.preguntas.length) * 100);
    const wpm = readTime > 0 ? Math.round((totalWords / readTime) * 60) : 0;
    const payload = {
      userId, lecturaId: `Evento de competencias`, titulo: lectura.titulo,
      fechaHora: new Date().toISOString(), semana,
      tiempoLecturaSegundos: readTime, palabrasPorMinuto: wpm,
      respuestasCorrectas: correct, totalPreguntas: lectura.preguntas.length,
      comprensionPorcentaje: comprension, respuestasDetalle: detail,
    };
    setResults(payload);
    setPhase("results");
    setSaving(true);
    try { await saveResultsToDB(payload, usuarioLogeado.idPerfil, totalWords, codigoCompetencia); setSaved(true); }
    catch { setSaveErr("No se pudo guardar. Intenta de nuevo."); }
    finally { setSaving(false); }
  }, [submitted, answers, lectura, readTime, totalWords, userId, semana]);

  const reset = () => {
     setSecs(0); setReadTime(0);
    setAnswers({}); setSubmitted(false);
    setSaving(false); setSaved(false); setSaveErr(null);
    setResults(null); setActiveQ(0);
    window.location.replace(dashboardRoutesPaths.dashboard);
  };

  const answered = Object.keys(answers).length;
  const allAnswered = answered === lectura.preguntas.length;

  // ── INTRO ──────────────────────────────────────────────────────────────────
  if (phase === "intro") return (
    <>
      <style>{CSS}</style>
      <div className="li" ref={scrollRef}>
        <Topbar semana={semana} right={
          <span className="li-chip li-chip-ghost">{totalWords} palabras</span>
        } />
        <div style={{ maxWidth: 660, margin: "0 auto", padding: "60px 24px 80px" }}>
          <div className="li-up0">
            <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginBottom: 22 }}>
              {(() => {
                const d = difficultyInfo(totalWords); return (
                  <span className={`li-chip ${d.chipClass}`}>{d.icon} Nivel {d.label}</span>
                );
              })()}
              <span className="li-chip li-chip-yellow">✏️ Evaluación Lectora</span>
            </div>
            <h1 style={{ fontFamily: "'Nunito',sans-serif", fontWeight: 900, fontSize: "clamp(24px,5vw,38px)", lineHeight: 1.2, color: C.white, marginBottom: 14 }}>
              {lectura.titulo}
            </h1>
            <div className="li-accent" />
            <p style={{ fontSize: 15, lineHeight: 1.75, color: C.muted, marginBottom: 38 }}>
              Lee el texto con atención y a tu ritmo natural. Al presionar{" "}
              <strong style={{ color: C.orange }}>Terminé de leer</strong>, se detendrá
              el cronómetro y comenzará el cuestionario de comprensión.
            </p>

            <div className="li-grid3 li-up1" style={{ marginBottom: 36 }}>
              {[
                { icon: "❓", key: "Preguntas", val: `${lectura.preguntas.length} reactivos` },
                { icon: "⏱️", key: "Tiempo", val: "Sin límite" },
              ].map((c) => (
                <div className="li-cell" key={c.key}>
                  <div className="li-cell-icon">{c.icon}</div>
                  <div className="li-cell-key">{c.key}</div>
                  <div className="li-cell-val">{c.val}</div>
                </div>
              ))}
              {/* Dificultad calculada dinámicamente */}
              {(() => {
                const d = difficultyInfo(totalWords);
                return (
                  <div className="li-cell" key="dificultad">
                    <div className="li-cell-icon">{d.icon}</div>
                    <div className="li-cell-key">Dificultad</div>
                    <div className="li-cell-val" style={{ color: d.color, fontWeight: 800 }}>{d.label}</div>
                  </div>
                );
              })()}
            </div>

            <button className="li-btn li-btn-primary li-up2" style={{ width: "100%", padding: "18px", fontSize: 16, borderRadius: 12 }} onClick={startReading}>
              Iniciar lectura →
            </button>
          </div>
        </div>
      </div>
    </>
  );

  // ── READING ────────────────────────────────────────────────────────────────
  if (phase === "reading") return (
    <>
      <style>{CSS}</style>
      <div className="li" ref={scrollRef}>
        <Topbar semana={semana} right={
          <>
            <Timer seconds={secs} on={true} />
            <button className="li-btn li-btn-primary" style={{ padding: "8px 20px", fontSize: 13 }} onClick={finishReading}>
              Terminé de leer ✓
            </button>
          </>
        } />

        <div style={{ maxWidth: 740, margin: "0 auto", padding: "52px 24px 100px" }}>
          <h2 className="li-up0" style={{ fontFamily: "'Nunito',sans-serif", fontWeight: 900, fontSize: "clamp(20px,4vw,30px)", color: C.white, marginBottom: 10 }}>
            {lectura.titulo}
          </h2>
          <div className="li-accent" />

          {lectura.texto.split("\n\n").map((para, i) => (
            <p className="li-para" key={i}>{para}</p>
          ))}

          <div className="li-div" />
          <div style={{ textAlign: "center" }}>
            <p style={{ color: C.muted, fontSize: 13, marginBottom: 16 }}>
              ¿Ya terminaste de leer el texto completo?
            </p>
            <button className="li-btn li-btn-primary" style={{ padding: "16px 52px", fontSize: 15, borderRadius: 12 }} onClick={finishReading}>
              Terminar lectura →
            </button>
          </div>
        </div>
      </div>
    </>
  );

  // ── QUIZ ───────────────────────────────────────────────────────────────────
  if (phase === "quiz") {
    const q = lectura.preguntas[activeQ];
    const isLast = activeQ === lectura.preguntas.length - 1;
    const cur = answers[q.id];

    return (
      <>
        <style>{CSS}</style>
        <div className="li" ref={scrollRef}>
          <Topbar semana={semana} right={
            <>
              <span style={{ fontFamily: "'Nunito',sans-serif", fontSize: 13, fontWeight: 800, color: C.orange }}>
                {answered}/{lectura.preguntas.length} respondidas
              </span>
              <Timer seconds={readTime} on={false} />
            </>
          } />

          <div style={{ maxWidth: 680, margin: "0 auto", padding: "40px 24px 80px" }}>
            <div className="li-up0" style={{ marginBottom: 26 }}>
              <ProgressBar current={answered} total={lectura.preguntas.length} />
            </div>

            <div className="li-up1" style={{ display: "flex", gap: 8, flexWrap: "wrap", marginBottom: 28 }}>
              {lectura.preguntas.map((pq, idx) => (
                <button
                  key={pq.id}
                  className={`li-qp${activeQ === idx ? " active" : answers[pq.id] ? " answered" : ""}`}
                  onClick={() => setActiveQ(idx)}
                >
                  {idx + 1}
                </button>
              ))}
            </div>

            <div key={q.id} className="li-card li-card-accent li-slide">
              <p style={{ fontFamily: "'Nunito',sans-serif", fontSize: 11, fontWeight: 700, letterSpacing: ".12em", textTransform: "uppercase", color: C.orange, marginBottom: 12 }}>
                Pregunta {activeQ + 1} de {lectura.preguntas.length}
              </p>
              <h3 style={{ fontFamily: "'Nunito',sans-serif", fontWeight: 800, fontSize: 18, lineHeight: 1.5, color: C.white, marginBottom: 22 }}>
                {q.pregunta}
              </h3>
              <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
                {q.opciones.map((op) => (
                  <button key={op} className={`li-opt${cur === op ? " sel" : ""}`} onClick={() => pickAnswer(q.id, op)}>
                    <span className="li-radio">{cur === op ? "✓" : ""}</span>
                    {op}
                  </button>
                ))}
              </div>

              <div style={{ marginTop: 28, display: "flex", justifyContent: "space-between", alignItems: "center", gap: 12 }}>
                <button className="li-btn li-btn-ghost" disabled={activeQ === 0} onClick={() => setActiveQ((i) => Math.max(0, i - 1))}>
                  ← Anterior
                </button>
                {isLast ? (
                  <button className="li-btn li-btn-primary" disabled={!allAnswered} onClick={submitQuiz}>
                    {allAnswered ? "Enviar respuestas ✓" : `Faltan ${lectura.preguntas.length - answered}`}
                  </button>
                ) : (
                  <button className="li-btn li-btn-primary" onClick={() => setActiveQ((i) => Math.min(lectura.preguntas.length - 1, i + 1))}>
                    Siguiente →
                  </button>
                )}
              </div>
            </div>

            {allAnswered && !isLast && (
              <div style={{ marginTop: 18, textAlign: "center" }}>
                <button className="li-btn li-btn-primary" style={{ padding: "14px 44px", fontSize: 15, borderRadius: 12 }} onClick={submitQuiz}>
                  Enviar todas las respuestas ✓
                </button>
              </div>
            )}
          </div>
        </div>
      </>
    );
  }

  // ── RESULTS ────────────────────────────────────────────────────────────────
  if (phase === "results" && results) {
    const sc = scoreInfo(results.comprensionPorcentaje);
    const wc = wpmInfo(results.palabrasPorMinuto);

    return (
      <>
        <style>{CSS}</style>
        <div className="li" ref={scrollRef}>
          <Topbar semana={semana} right={
            <span className="li-chip li-chip-ghost">Resultados</span>
          } />

          <div style={{ maxWidth: 720, margin: "0 auto", padding: "56px 24px 80px" }}>
            {/* header */}
            <div className="li-up0" style={{ marginBottom: 36 }}>
              <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginBottom: 14 }}>
                <span className="li-chip li-chip-orange">Evento de competencias </span>
                <span className="li-chip" style={{ background: `${sc.color}15`, border: `1.5px solid ${sc.color}55`, color: sc.color }}>
                  {sc.label}
                </span>
              </div>
              <h2 style={{ fontFamily: "'Nunito',sans-serif", fontWeight: 900, fontSize: "clamp(22px,4vw,34px)", color: C.white, marginBottom: 10 }}>
                Ejercicio Completado
              </h2>
              <div className="li-accent" />
              <p style={{ fontSize: 13, color: C.muted }}>
                {new Date(results.fechaHora).toLocaleString("es-MX", { dateStyle: "long", timeStyle: "short" })}
              </p>
            </div>

            {/* metric cards */}
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(175px,1fr))", gap: 14, marginBottom: 28 }}>
              <MetricCard label="Comprensión" value={`${results.comprensionPorcentaje}%`} sub={`${results.respuestasCorrectas}/${results.totalPreguntas} correctas`} color={sc.color} cls="li-up0" />

              <MetricCard label="Velocidad lectora" value={results.palabrasPorMinuto} sub={`ppm · ${wc.label}`} color={wc.color} cls="li-up1" />
              
              <MetricCard label="Tiempo de lectura" value={formatTime(results.tiempoLecturaSegundos)} sub={`${totalWords} palabras`} color={C.orange} cls="li-up2" />
            </div>

            {/* distribution */}
            <div className="li-card li-up2" style={{ marginBottom: 24 }}>
              <p style={{ fontFamily: "'Nunito',sans-serif", fontSize: 11, fontWeight: 700, letterSpacing: ".1em", textTransform: "uppercase", color: C.muted, marginBottom: 14 }}>
                Distribución por pregunta
              </p>
              <div className="li-distbar">
                {results.respuestasDetalle.map((d, i) => (
                  <div
                    key={d.id}
                    className="li-distcell"
                    title={`P${i + 1}: ${d.correcta ? "Correcta" : "Incorrecta"}`}
                    style={{ background: d.correcta ? "#166534" : "#7f1d1d", color: d.correcta ? "#4ade80" : "#f87171" }}
                  >
                    {i + 1}
                  </div>
                ))}
              </div>
              <div style={{ display: "flex", gap: 16, marginTop: 12 }}>
                {[["#166534", "#4ade80", "Correcta"], ["#7f1d1d", "#f87171", "Incorrecta"]].map(([bg, clr, lbl]) => (
                  <span key={lbl} style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 12, color: clr }}>
                    <span style={{ width: 10, height: 10, borderRadius: 3, background: bg, display: "inline-block" }} />{lbl}
                  </span>
                ))}
              </div>
            </div>

            {/* detail */}
            <div className="li-up3">
              <h3 style={{ fontFamily: "'Nunito',sans-serif", fontWeight: 800, fontSize: 17, color: C.white, marginBottom: 14 }}>
                Desglose de respuestas
              </h3>
              <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
                {results.respuestasDetalle.map((d, i) => (
                  <div key={d.id} className={`li-row ${d.correcta ? "ok" : "err"}`}>
                    <span className="li-row-icon">{d.correcta ? "✓" : "✗"}</span>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <p style={{ fontFamily: "'Nunito',sans-serif", fontSize: 13, fontWeight: 700, color: C.white, marginBottom: 5 }}>
                        {i + 1}. {d.pregunta}
                      </p>
                      <p style={{ fontSize: 12, color: d.correcta ? "#4ade80" : "#f87171", marginBottom: d.correcta ? 0 : 3 }}>
                        Tu respuesta: {d.seleccionada ?? "Sin respuesta"}
                      </p>
                      {!d.correcta && (
                        <p style={{ fontSize: 12, color: "#4ade80" }}>
                          Respuesta correcta: {d.respuestaCorrecta}
                        </p>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="li-div" />

            {/* save status */}
            <div className={`li-save ${saving ? "saving" : saved ? "success" : saveErr ? "error" : "saving"}`}>
              {saving && <><span>⏳</span> Guardando resultados en la base de datos...</>}
              {saved && <><span>✅</span> Resultados guardados</>}
              {saveErr && <><span>⚠️</span> {saveErr}</>}
            </div>

            <div style={{ marginTop: 20, textAlign: "center" }}>
              <button className="li-btn li-btn-ghost" onClick={reset}>
                Finalizar ejercicio
              </button>
            </div>
          </div>
        </div>
      </>
    );
  }

  return null;
}